export const OWF_BACKGROUND: string =
  "https://cdn.faire.com/fastly/6640d0ceb76c09d9ca83b3739218494d9af01642fc3289bdbd8b217e5d994fa7.png";
